import styled from "styled-components";

export default styled.section`
	--gap: var(--spacing-x-large);
	display: flex;
	padding: var(--gap);
	gap: var(--gap);
	scrollbar-gutter: stable;
`;